<!--
  CollectorAuthCard — «افتح يومك من تيليجرام» (collector-app P2-B, locked
  answer L-D). Shown on the day and shop pages while the queue waits for a
  login (a 401 or 419 came back). His day and his taps stay on the phone and
  on screen; this is the only thing that changes. ONE button, the same way
  back LaunchPage offers (utils/launchTarget.js `openTelegramBot`): the bot in
  Telegram, from where the launch handoff signs him in again — and the queue
  sends itself.
-->
<template>
  <section v-if="authPaused" class="c-auth-card" role="status">
    <div class="c-auth-card__title">
      {{ t('collector.auth.title') }}
    </div>
    <div class="c-auth-card__body">
      {{ t('collector.auth.body') }}
    </div>
    <button type="button" class="c-reset c-auth-card__btn" @click="open">
      {{ t('collector.auth.open') }}
    </button>
  </section>
</template>

<script setup>
import { f7 } from 'framework7-vue';
import { useI18n } from 'vue-i18n';
import { authPaused } from '@/collector/session.js';
import { openTelegramBot } from '@/utils/launchTarget.js';

const { t } = useI18n();

function open() {
  openTelegramBot({
    fallback: () => f7?.views?.main?.router?.navigate('/login/', { clearPreviousHistory: true }),
  });
}
</script>

<style scoped>
.c-auth-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 16px 0;
  padding: 14px;
  background: var(--c-card);
  border: 2px solid var(--c-amber-border);
  border-radius: var(--c-radius-row);
}

.c-auth-card__title {
  font-size: 15px;
  font-weight: 700;
}

.c-auth-card__body {
  font-size: 13px;
  color: var(--c-ink-soft);
}

.c-auth-card__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-radius: var(--c-radius-button);
  background: var(--c-indigo);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}
</style>
